import Ajax from '../../../lib/ajax';
import { ActionContext } from 'vuex';

interface TransactionState {
  loading: boolean;
  transactionData: any;
  dealerModels: any[];
}

const state: TransactionState = {
  loading: false,
  transactionData: null,
  dealerModels: [],
};

const transactionModule = {
  namespaced: true,
  state,
  actions: {
    async processApiTransaction(context: ActionContext<TransactionState, any>) {
      context.state.loading = true;
      try {
        const response = await Ajax.get('/api/transaction-api');
        context.state.loading = false;
        context.commit('setTransactionData', response.data.result);
        return response.data.result;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async getTransactionSummary(context: ActionContext<TransactionState, any>, payload: any) {
      context.state.loading = true;
      try {
        const response = await Ajax.get('/api/transaction-summary', {
          params: payload,
        });
        context.state.loading = false;

        context.commit('setTransactionData', response.data.result);
        return response.data.result;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async storeOffices(context: ActionContext<TransactionState, any>) {
      context.state.loading = true;
      try {
        const response = await Ajax.get('/api/transaction-stored-offices');
        context.state.loading = false;

        return response.data;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async storeObjectives(context: ActionContext<TransactionState, any>, payload: any) {
      context.state.loading = true;
      try {
        const response = await Ajax.post('/api/dispatches-objectives', payload);
        context.state.loading = false;
        return response.data;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async getObjectivesSummary(context: ActionContext<TransactionState, any>, payload: any) {
      context.state.loading = true;
      try {
        const response = await Ajax.get('/api/objectives-summary', {
          params: payload,
        });
        context.state.loading = false;

        return response.data.result;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async downloadReport(context: ActionContext<TransactionState, any>, manufacturer: string) {
      context.state.loading = true;
      try {
        const response = await Ajax.get('/api/transaction/report-export', {
          params: { manufacturer },
          responseType: 'blob',
        });
        context.state.loading = false;
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Formato_Objetivos.xlsx');
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        return true;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async downloadDynamicReport(context: ActionContext<TransactionState, any>, payload: any) {
      context.state.loading = true;
      try {
        const response = await Ajax.post('/api/transaction/export-dynamic-report', payload, {
          responseType: 'blob',
        });
        context.state.loading = false;
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${payload.title_download || 'Reporte'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        return true;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

    async exportInternalReport(context: ActionContext<TransactionState, any>, payload: any) {
      context.state.loading = true;
      try {
        const response = await Ajax.post('/api/transaction/export-internal-report', payload, {
          responseType: 'blob',
        });
        context.state.loading = false;

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const firstMonth = payload.monthHeaders[0];
        const lastMonth = payload.monthHeaders[payload.monthHeaders.length - 1];
        const monthText = firstMonth === lastMonth ? firstMonth : `${firstMonth}-${lastMonth}`;

        link.setAttribute(
          'download',
          `Reporte-Despachos-${payload.marcaSeleccionada}-${payload.rangeFrom.year}-${monthText}.xlsx`
        );

        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        return true;
      } catch (error) {
        context.state.loading = false;
        return Promise.reject(error);
      }
    },

  },
  mutations: {
    setTransactionData(state: TransactionState, data: any) {
      state.transactionData = data;
    },
  },
};

export default transactionModule;
